export const CURRENCIES = [
  { country: 'AFGHANISTAN', name: 'Afghani', alphabetic_code: 'AFN', numeric_code: 971, exponent: 2 },
  { country: 'ÅLAND ISLANDS', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'ALBANIA', name: 'Lek', alphabetic_code: 'ALL', numeric_code: 8, exponent: 2 },
  { country: 'ALGERIA', name: 'Algerian Dinar', alphabetic_code: 'DZD', numeric_code: 12, exponent: 2 },
  { country: 'AMERICAN SAMOA', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'ANDORRA', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'ANGOLA', name: 'Kwanza', alphabetic_code: 'AOA', numeric_code: 973, exponent: 2 },
  { country: 'ANGUILLA', name: 'East Caribbean Dollar', alphabetic_code: 'XCD', numeric_code: 951, exponent: 2 },
  { country: 'ANTARCTICA', name: 'No universal currency', alphabetic_code: '', numeric_code: null, exponent: null },
  { country: 'ANTIGUA AND BARBUDA', name: 'East Caribbean Dollar', alphabetic_code: 'XCD', numeric_code: 951, exponent: 2 },
  { country: 'ARGENTINA', name: 'Argentine Peso', alphabetic_code: 'ARS', numeric_code: 32, exponent: 2 },
  { country: 'ARMENIA', name: 'Armenian Dram', alphabetic_code: 'AMD', numeric_code: 51, exponent: 2 },
  { country: 'ARUBA', name: 'Aruban Florin', alphabetic_code: 'AWG', numeric_code: 533, exponent: 2 },
  { country: 'AUSTRALIA', name: 'Australian Dollar', alphabetic_code: 'AUD', numeric_code: 36, exponent: 2 },
  { country: 'AUSTRIA', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'AZERBAIJAN', name: 'Azerbaijan Manat', alphabetic_code: 'AZN', numeric_code: 944, exponent: 2 },
  { country: 'BAHAMAS (THE)', name: 'Bahamian Dollar', alphabetic_code: 'BSD', numeric_code: 44, exponent: 2 },
  { country: 'BAHRAIN', name: 'Bahraini Dinar', alphabetic_code: 'BHD', numeric_code: 48, exponent: 3 },
  { country: 'BANGLADESH', name: 'Taka', alphabetic_code: 'BDT', numeric_code: 50, exponent: 2 },
  { country: 'BARBADOS', name: 'Barbados Dollar', alphabetic_code: 'BBD', numeric_code: 52, exponent: 2 },
  { country: 'BELARUS', name: 'Belarusian Ruble', alphabetic_code: 'BYN', numeric_code: 933, exponent: 2 },
  { country: 'BELGIUM', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'BELIZE', name: 'Belize Dollar', alphabetic_code: 'BZD', numeric_code: 84, exponent: 2 },
  { country: 'BENIN', name: 'CFA Franc BCEAO', alphabetic_code: 'XOF', numeric_code: 952, exponent: 0 },
  { country: 'BERMUDA', name: 'Bermudian Dollar', alphabetic_code: 'BMD', numeric_code: 60, exponent: 2 },
  { country: 'BHUTAN', name: 'Indian Rupee', alphabetic_code: 'INR', numeric_code: 356, exponent: 2 },
  { country: 'BHUTAN', name: 'Ngultrum', alphabetic_code: 'BTN', numeric_code: 64, exponent: 2 },
  { country: 'BOLIVIA (PLURINATIONAL STATE OF)', name: 'Boliviano', alphabetic_code: 'BOB', numeric_code: 68, exponent: 2 },
  { country: 'BOLIVIA (PLURINATIONAL STATE OF)', name: 'Mvdol', alphabetic_code: 'BOV', numeric_code: 984, exponent: 2 },
  { country: 'BONAIRE, SINT EUSTATIUS AND SABA', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'BOSNIA AND HERZEGOVINA', name: 'Convertible Mark', alphabetic_code: 'BAM', numeric_code: 977, exponent: 2 },
  { country: 'BOTSWANA', name: 'Pula', alphabetic_code: 'BWP', numeric_code: 72, exponent: 2 },
  { country: 'BOUVET ISLAND', name: 'Norwegian Krone', alphabetic_code: 'NOK', numeric_code: 578, exponent: 2 },
  { country: 'BRAZIL', name: 'Brazilian Real', alphabetic_code: 'BRL', numeric_code: 986, exponent: 2 },
  { country: 'BRITISH INDIAN OCEAN TERRITORY (THE)', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'BRUNEI DARUSSALAM', name: 'Brunei Dollar', alphabetic_code: 'BND', numeric_code: 96, exponent: 2 },
  { country: 'BULGARIA', name: 'Bulgarian Lev', alphabetic_code: 'BGN', numeric_code: 975, exponent: 2 },
  { country: 'BURKINA FASO', name: 'CFA Franc BCEAO', alphabetic_code: 'XOF', numeric_code: 952, exponent: 0 },
  { country: 'BURUNDI', name: 'Burundi Franc', alphabetic_code: 'BIF', numeric_code: 108, exponent: 0 },
  { country: 'CABO VERDE', name: 'Cabo Verde Escudo', alphabetic_code: 'CVE', numeric_code: 132, exponent: 2 },
  { country: 'CAMBODIA', name: 'Riel', alphabetic_code: 'KHR', numeric_code: 116, exponent: 2 },
  { country: 'CAMEROON', name: 'CFA Franc BEAC', alphabetic_code: 'XAF', numeric_code: 950, exponent: 0 },
  { country: 'CANADA', name: 'Canadian Dollar', alphabetic_code: 'CAD', numeric_code: 124, exponent: 2 },
  { country: 'CAYMAN ISLANDS (THE)', name: 'Cayman Islands Dollar', alphabetic_code: 'KYD', numeric_code: 136, exponent: 2 },
  { country: 'CENTRAL AFRICAN REPUBLIC (THE)', name: 'CFA Franc BEAC', alphabetic_code: 'XAF', numeric_code: 950, exponent: 0 },
  { country: 'CHAD', name: 'CFA Franc BEAC', alphabetic_code: 'XAF', numeric_code: 950, exponent: 0 },
  { country: 'CHILE', name: 'Chilean Peso', alphabetic_code: 'CLP', numeric_code: 152, exponent: 0 },
  { country: 'CHILE', name: 'Unidad de Fomento', alphabetic_code: 'CLF', numeric_code: 990, exponent: 4 },
  { country: 'CHINA', name: 'Yuan Renminbi', alphabetic_code: 'CNY', numeric_code: 156, exponent: 2 },
  { country: 'CHRISTMAS ISLAND', name: 'Australian Dollar', alphabetic_code: 'AUD', numeric_code: 36, exponent: 2 },
  { country: 'COCOS (KEELING) ISLANDS (THE)', name: 'Australian Dollar', alphabetic_code: 'AUD', numeric_code: 36, exponent: 2 },
  { country: 'COLOMBIA', name: 'Colombian Peso', alphabetic_code: 'COP', numeric_code: 170, exponent: 2 },
  { country: 'COLOMBIA', name: 'Unidad de Valor Real', alphabetic_code: 'COU', numeric_code: 970, exponent: 2 },
  { country: 'COMOROS (THE)', name: 'Comorian Franc ', alphabetic_code: 'KMF', numeric_code: 174, exponent: 0 },
  {
    country: 'CONGO (THE DEMOCRATIC REPUBLIC OF THE)',
    name: 'Congolese Franc',
    alphabetic_code: 'CDF',
    numeric_code: 976,
    exponent: 2
  },
  { country: 'CONGO (THE)', name: 'CFA Franc BEAC', alphabetic_code: 'XAF', numeric_code: 950, exponent: 0 },
  { country: 'COOK ISLANDS (THE)', name: 'New Zealand Dollar', alphabetic_code: 'NZD', numeric_code: 554, exponent: 2 },
  { country: 'COSTA RICA', name: 'Costa Rican Colon', alphabetic_code: 'CRC', numeric_code: 188, exponent: 2 },
  { country: "CÔTE D'IVOIRE", name: 'CFA Franc BCEAO', alphabetic_code: 'XOF', numeric_code: 952, exponent: 0 },
  { country: 'CROATIA', name: 'Kuna', alphabetic_code: 'HRK', numeric_code: 191, exponent: 2 },
  { country: 'CUBA', name: 'Cuban Peso', alphabetic_code: 'CUP', numeric_code: 192, exponent: 2 },
  { country: 'CUBA', name: 'Peso Convertible', alphabetic_code: 'CUC', numeric_code: 931, exponent: 2 },
  { country: 'CURAÇAO', name: 'Netherlands Antillean Guilder', alphabetic_code: 'ANG', numeric_code: 532, exponent: 2 },
  { country: 'CYPRUS', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'CZECHIA', name: 'Czech Koruna', alphabetic_code: 'CZK', numeric_code: 203, exponent: 2 },
  { country: 'DENMARK', name: 'Danish Krone', alphabetic_code: 'DKK', numeric_code: 208, exponent: 2 },
  { country: 'DJIBOUTI', name: 'Djibouti Franc', alphabetic_code: 'DJF', numeric_code: 262, exponent: 0 },
  { country: 'DOMINICA', name: 'East Caribbean Dollar', alphabetic_code: 'XCD', numeric_code: 951, exponent: 2 },
  { country: 'DOMINICAN REPUBLIC (THE)', name: 'Dominican Peso', alphabetic_code: 'DOP', numeric_code: 214, exponent: 2 },
  { country: 'ECUADOR', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'EGYPT', name: 'Egyptian Pound', alphabetic_code: 'EGP', numeric_code: 818, exponent: 2 },
  { country: 'EL SALVADOR', name: 'El Salvador Colon', alphabetic_code: 'SVC', numeric_code: 222, exponent: 2 },
  { country: 'EL SALVADOR', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'EQUATORIAL GUINEA', name: 'CFA Franc BEAC', alphabetic_code: 'XAF', numeric_code: 950, exponent: 0 },
  { country: 'ERITREA', name: 'Nakfa', alphabetic_code: 'ERN', numeric_code: 232, exponent: 2 },
  { country: 'ESTONIA', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'ETHIOPIA', name: 'Ethiopian Birr', alphabetic_code: 'ETB', numeric_code: 230, exponent: 2 },
  { country: 'EUROPEAN UNION', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  {
    country: 'FALKLAND ISLANDS (THE) [MALVINAS]',
    name: 'Falkland Islands Pound',
    alphabetic_code: 'FKP',
    numeric_code: 238,
    exponent: 2
  },
  { country: 'FAROE ISLANDS (THE)', name: 'Danish Krone', alphabetic_code: 'DKK', numeric_code: 208, exponent: 2 },
  { country: 'FIJI', name: 'Fiji Dollar', alphabetic_code: 'FJD', numeric_code: 242, exponent: 2 },
  { country: 'FINLAND', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'FRANCE', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'FRENCH GUIANA', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'FRENCH POLYNESIA', name: 'CFP Franc', alphabetic_code: 'XPF', numeric_code: 953, exponent: 0 },
  { country: 'FRENCH SOUTHERN TERRITORIES (THE)', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'GABON', name: 'CFA Franc BEAC', alphabetic_code: 'XAF', numeric_code: 950, exponent: 0 },
  { country: 'GAMBIA (THE)', name: 'Dalasi', alphabetic_code: 'GMD', numeric_code: 270, exponent: 2 },
  { country: 'GEORGIA', name: 'Lari', alphabetic_code: 'GEL', numeric_code: 981, exponent: 2 },
  { country: 'GERMANY', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'GHANA', name: 'Ghana Cedi', alphabetic_code: 'GHS', numeric_code: 936, exponent: 2 },
  { country: 'GIBRALTAR', name: 'Gibraltar Pound', alphabetic_code: 'GIP', numeric_code: 292, exponent: 2 },
  { country: 'GREECE', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'GREENLAND', name: 'Danish Krone', alphabetic_code: 'DKK', numeric_code: 208, exponent: 2 },
  { country: 'GRENADA', name: 'East Caribbean Dollar', alphabetic_code: 'XCD', numeric_code: 951, exponent: 2 },
  { country: 'GUADELOUPE', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'GUAM', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'GUATEMALA', name: 'Quetzal', alphabetic_code: 'GTQ', numeric_code: 320, exponent: 2 },
  { country: 'GUERNSEY', name: 'Pound Sterling', alphabetic_code: 'GBP', numeric_code: 826, exponent: 2 },
  { country: 'GUINEA', name: 'Guinean Franc', alphabetic_code: 'GNF', numeric_code: 324, exponent: 0 },
  { country: 'GUINEA-BISSAU', name: 'CFA Franc BCEAO', alphabetic_code: 'XOF', numeric_code: 952, exponent: 0 },
  { country: 'GUYANA', name: 'Guyana Dollar', alphabetic_code: 'GYD', numeric_code: 328, exponent: 2 },
  { country: 'HAITI', name: 'Gourde', alphabetic_code: 'HTG', numeric_code: 332, exponent: 2 },
  { country: 'HAITI', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  {
    country: 'HEARD ISLAND AND McDONALD ISLANDS',
    name: 'Australian Dollar',
    alphabetic_code: 'AUD',
    numeric_code: 36,
    exponent: 2
  },
  { country: 'HOLY SEE (THE)', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'HONDURAS', name: 'Lempira', alphabetic_code: 'HNL', numeric_code: 340, exponent: 2 },
  { country: 'HONG KONG', name: 'Hong Kong Dollar', alphabetic_code: 'HKD', numeric_code: 344, exponent: 2 },
  { country: 'HUNGARY', name: 'Forint', alphabetic_code: 'HUF', numeric_code: 348, exponent: 2 },
  { country: 'ICELAND', name: 'Iceland Krona', alphabetic_code: 'ISK', numeric_code: 352, exponent: 0 },
  { country: 'INDIA', name: 'Indian Rupee', alphabetic_code: 'INR', numeric_code: 356, exponent: 2 },
  { country: 'INDONESIA', name: 'Rupiah', alphabetic_code: 'IDR', numeric_code: 360, exponent: 2 },
  {
    country: 'INTERNATIONAL MONETARY FUND (IMF) ',
    name: 'SDR (Special Drawing Right)',
    alphabetic_code: 'XDR',
    numeric_code: 960,
    exponent: null
  },
  { country: 'IRAN (ISLAMIC REPUBLIC OF)', name: 'Iranian Rial', alphabetic_code: 'IRR', numeric_code: 364, exponent: 2 },
  { country: 'IRAQ', name: 'Iraqi Dinar', alphabetic_code: 'IQD', numeric_code: 368, exponent: 3 },
  { country: 'IRELAND', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'ISLE OF MAN', name: 'Pound Sterling', alphabetic_code: 'GBP', numeric_code: 826, exponent: 2 },
  { country: 'ISRAEL', name: 'New Israeli Sheqel', alphabetic_code: 'ILS', numeric_code: 376, exponent: 2 },
  { country: 'ITALY', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'JAMAICA', name: 'Jamaican Dollar', alphabetic_code: 'JMD', numeric_code: 388, exponent: 2 },
  { country: 'JAPAN', name: 'Yen', alphabetic_code: 'JPY', numeric_code: 392, exponent: 0 },
  { country: 'JERSEY', name: 'Pound Sterling', alphabetic_code: 'GBP', numeric_code: 826, exponent: 2 },
  { country: 'JORDAN', name: 'Jordanian Dinar', alphabetic_code: 'JOD', numeric_code: 400, exponent: 3 },
  { country: 'KAZAKHSTAN', name: 'Tenge', alphabetic_code: 'KZT', numeric_code: 398, exponent: 2 },
  { country: 'KENYA', name: 'Kenyan Shilling', alphabetic_code: 'KES', numeric_code: 404, exponent: 2 },
  { country: 'KIRIBATI', name: 'Australian Dollar', alphabetic_code: 'AUD', numeric_code: 36, exponent: 2 },
  {
    country: 'KOREA (THE DEMOCRATIC PEOPLE’S REPUBLIC OF)',
    name: 'North Korean Won',
    alphabetic_code: 'KPW',
    numeric_code: 408,
    exponent: 2
  },
  { country: 'KOREA (THE REPUBLIC OF)', name: 'Won', alphabetic_code: 'KRW', numeric_code: 410, exponent: 0 },
  { country: 'KUWAIT', name: 'Kuwaiti Dinar', alphabetic_code: 'KWD', numeric_code: 414, exponent: 3 },
  { country: 'KYRGYZSTAN', name: 'Som', alphabetic_code: 'KGS', numeric_code: 417, exponent: 2 },
  { country: 'LAO PEOPLE’S DEMOCRATIC REPUBLIC (THE)', name: 'Lao Kip', alphabetic_code: 'LAK', numeric_code: 418, exponent: 2 },
  { country: 'LATVIA', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'LEBANON', name: 'Lebanese Pound', alphabetic_code: 'LBP', numeric_code: 422, exponent: 2 },
  { country: 'LESOTHO', name: 'Loti', alphabetic_code: 'LSL', numeric_code: 426, exponent: 2 },
  { country: 'LESOTHO', name: 'Rand', alphabetic_code: 'ZAR', numeric_code: 710, exponent: 2 },
  { country: 'LIBERIA', name: 'Liberian Dollar', alphabetic_code: 'LRD', numeric_code: 430, exponent: 2 },
  { country: 'LIBYA', name: 'Libyan Dinar', alphabetic_code: 'LYD', numeric_code: 434, exponent: 3 },
  { country: 'LIECHTENSTEIN', name: 'Swiss Franc', alphabetic_code: 'CHF', numeric_code: 756, exponent: 2 },
  { country: 'LITHUANIA', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'LUXEMBOURG', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'MACAO', name: 'Pataca', alphabetic_code: 'MOP', numeric_code: 446, exponent: 2 },
  {
    country: 'MACEDONIA (THE FORMER YUGOSLAV REPUBLIC OF)',
    name: 'Denar',
    alphabetic_code: 'MKD',
    numeric_code: 807,
    exponent: 2
  },
  { country: 'MADAGASCAR', name: 'Malagasy Ariary', alphabetic_code: 'MGA', numeric_code: 969, exponent: 2 },
  { country: 'MALAWI', name: 'Malawi Kwacha', alphabetic_code: 'MWK', numeric_code: 454, exponent: 2 },
  { country: 'MALAYSIA', name: 'Malaysian Ringgit', alphabetic_code: 'MYR', numeric_code: 458, exponent: 2 },
  { country: 'MALDIVES', name: 'Rufiyaa', alphabetic_code: 'MVR', numeric_code: 462, exponent: 2 },
  { country: 'MALI', name: 'CFA Franc BCEAO', alphabetic_code: 'XOF', numeric_code: 952, exponent: 0 },
  { country: 'MALTA', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'MARSHALL ISLANDS (THE)', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'MARTINIQUE', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'MAURITANIA', name: 'Ouguiya', alphabetic_code: 'MRU', numeric_code: 929, exponent: 2 },
  { country: 'MAURITIUS', name: 'Mauritius Rupee', alphabetic_code: 'MUR', numeric_code: 480, exponent: 2 },
  { country: 'MAYOTTE', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  {
    country: 'MEMBER COUNTRIES OF THE AFRICAN DEVELOPMENT BANK GROUP',
    name: 'ADB Unit of Account',
    alphabetic_code: 'XUA',
    numeric_code: 965,
    exponent: null
  },
  { country: 'MEXICO', name: 'Mexican Peso', alphabetic_code: 'MXN', numeric_code: 484, exponent: 2 },
  { country: 'MEXICO', name: 'Mexican Unidad de Inversion (UDI)', alphabetic_code: 'MXV', numeric_code: 979, exponent: 2 },
  { country: 'MICRONESIA (FEDERATED STATES OF)', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'MOLDOVA (THE REPUBLIC OF)', name: 'Moldovan Leu', alphabetic_code: 'MDL', numeric_code: 498, exponent: 2 },
  { country: 'MONACO', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'MONGOLIA', name: 'Tugrik', alphabetic_code: 'MNT', numeric_code: 496, exponent: 2 },
  { country: 'MONTENEGRO', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'MONTSERRAT', name: 'East Caribbean Dollar', alphabetic_code: 'XCD', numeric_code: 951, exponent: 2 },
  { country: 'MOROCCO', name: 'Moroccan Dirham', alphabetic_code: 'MAD', numeric_code: 504, exponent: 2 },
  { country: 'MOZAMBIQUE', name: 'Mozambique Metical', alphabetic_code: 'MZN', numeric_code: 943, exponent: 2 },
  { country: 'MYANMAR', name: 'Kyat', alphabetic_code: 'MMK', numeric_code: 104, exponent: 2 },
  { country: 'NAMIBIA', name: 'Namibia Dollar', alphabetic_code: 'NAD', numeric_code: 516, exponent: 2 },
  { country: 'NAMIBIA', name: 'Rand', alphabetic_code: 'ZAR', numeric_code: 710, exponent: 2 },
  { country: 'NAURU', name: 'Australian Dollar', alphabetic_code: 'AUD', numeric_code: 36, exponent: 2 },
  { country: 'NEPAL', name: 'Nepalese Rupee', alphabetic_code: 'NPR', numeric_code: 524, exponent: 2 },
  { country: 'NETHERLANDS (THE)', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'NEW CALEDONIA', name: 'CFP Franc', alphabetic_code: 'XPF', numeric_code: 953, exponent: 0 },
  { country: 'NEW ZEALAND', name: 'New Zealand Dollar', alphabetic_code: 'NZD', numeric_code: 554, exponent: 2 },
  { country: 'NICARAGUA', name: 'Cordoba Oro', alphabetic_code: 'NIO', numeric_code: 558, exponent: 2 },
  { country: 'NIGER (THE)', name: 'CFA Franc BCEAO', alphabetic_code: 'XOF', numeric_code: 952, exponent: 0 },
  { country: 'NIGERIA', name: 'Naira', alphabetic_code: 'NGN', numeric_code: 566, exponent: 2 },
  { country: 'NIUE', name: 'New Zealand Dollar', alphabetic_code: 'NZD', numeric_code: 554, exponent: 2 },
  { country: 'NORFOLK ISLAND', name: 'Australian Dollar', alphabetic_code: 'AUD', numeric_code: 36, exponent: 2 },
  { country: 'NORTHERN MARIANA ISLANDS (THE)', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'NORWAY', name: 'Norwegian Krone', alphabetic_code: 'NOK', numeric_code: 578, exponent: 2 },
  { country: 'OMAN', name: 'Rial Omani', alphabetic_code: 'OMR', numeric_code: 512, exponent: 3 },
  { country: 'PAKISTAN', name: 'Pakistan Rupee', alphabetic_code: 'PKR', numeric_code: 586, exponent: 2 },
  { country: 'PALAU', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'PALESTINE, STATE OF', name: 'No universal currency', alphabetic_code: '', numeric_code: null, exponent: null },
  { country: 'PANAMA', name: 'Balboa', alphabetic_code: 'PAB', numeric_code: 590, exponent: 2 },
  { country: 'PANAMA', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'PAPUA NEW GUINEA', name: 'Kina', alphabetic_code: 'PGK', numeric_code: 598, exponent: 2 },
  { country: 'PARAGUAY', name: 'Guarani', alphabetic_code: 'PYG', numeric_code: 600, exponent: 0 },
  { country: 'PERU', name: 'Sol', alphabetic_code: 'PEN', numeric_code: 604, exponent: 2 },
  { country: 'PHILIPPINES (THE)', name: 'Philippine Peso', alphabetic_code: 'PHP', numeric_code: 608, exponent: 2 },
  { country: 'PITCAIRN', name: 'New Zealand Dollar', alphabetic_code: 'NZD', numeric_code: 554, exponent: 2 },
  { country: 'POLAND', name: 'Zloty', alphabetic_code: 'PLN', numeric_code: 985, exponent: 2 },
  { country: 'PORTUGAL', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'PUERTO RICO', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'QATAR', name: 'Qatari Rial', alphabetic_code: 'QAR', numeric_code: 634, exponent: 2 },
  { country: 'RÉUNION', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'ROMANIA', name: 'Romanian Leu', alphabetic_code: 'RON', numeric_code: 946, exponent: 2 },
  { country: 'RUSSIAN FEDERATION (THE)', name: 'Russian Ruble', alphabetic_code: 'RUB', numeric_code: 643, exponent: 2 },
  { country: 'RWANDA', name: 'Rwanda Franc', alphabetic_code: 'RWF', numeric_code: 646, exponent: 0 },
  { country: 'SAINT BARTHÉLEMY', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  {
    country: 'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA',
    name: 'Saint Helena Pound',
    alphabetic_code: 'SHP',
    numeric_code: 654,
    exponent: 2
  },
  { country: 'SAINT KITTS AND NEVIS', name: 'East Caribbean Dollar', alphabetic_code: 'XCD', numeric_code: 951, exponent: 2 },
  { country: 'SAINT LUCIA', name: 'East Caribbean Dollar', alphabetic_code: 'XCD', numeric_code: 951, exponent: 2 },
  { country: 'SAINT MARTIN (FRENCH PART)', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'SAINT PIERRE AND MIQUELON', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  {
    country: 'SAINT VINCENT AND THE GRENADINES',
    name: 'East Caribbean Dollar',
    alphabetic_code: 'XCD',
    numeric_code: 951,
    exponent: 2
  },
  { country: 'SAMOA', name: 'Tala', alphabetic_code: 'WST', numeric_code: 882, exponent: 2 },
  { country: 'SAN MARINO', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'SAO TOME AND PRINCIPE', name: 'Dobra', alphabetic_code: 'STN', numeric_code: 930, exponent: 2 },
  { country: 'SAUDI ARABIA', name: 'Saudi Riyal', alphabetic_code: 'SAR', numeric_code: 682, exponent: 2 },
  { country: 'SENEGAL', name: 'CFA Franc BCEAO', alphabetic_code: 'XOF', numeric_code: 952, exponent: 0 },
  { country: 'SERBIA', name: 'Serbian Dinar', alphabetic_code: 'RSD', numeric_code: 941, exponent: 2 },
  { country: 'SEYCHELLES', name: 'Seychelles Rupee', alphabetic_code: 'SCR', numeric_code: 690, exponent: 2 },
  { country: 'SIERRA LEONE', name: 'Leone', alphabetic_code: 'SLL', numeric_code: 694, exponent: 2 },
  { country: 'SINGAPORE', name: 'Singapore Dollar', alphabetic_code: 'SGD', numeric_code: 702, exponent: 2 },
  {
    country: 'SINT MAARTEN (DUTCH PART)',
    name: 'Netherlands Antillean Guilder',
    alphabetic_code: 'ANG',
    numeric_code: 532,
    exponent: 2
  },
  {
    country: 'SISTEMA UNITARIO DE COMPENSACION REGIONAL DE PAGOS "SUCRE"',
    name: 'Sucre',
    alphabetic_code: 'XSU',
    numeric_code: 994,
    exponent: null
  },
  { country: 'SLOVAKIA', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'SLOVENIA', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'SOLOMON ISLANDS', name: 'Solomon Islands Dollar', alphabetic_code: 'SBD', numeric_code: 90, exponent: 2 },
  { country: 'SOMALIA', name: 'Somali Shilling', alphabetic_code: 'SOS', numeric_code: 706, exponent: 2 },
  { country: 'SOUTH AFRICA', name: 'Rand', alphabetic_code: 'ZAR', numeric_code: 710, exponent: 2 },
  {
    country: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
    name: 'No universal currency',
    alphabetic_code: '',
    numeric_code: null,
    exponent: null
  },
  { country: 'SOUTH SUDAN', name: 'South Sudanese Pound', alphabetic_code: 'SSP', numeric_code: 728, exponent: 2 },
  { country: 'SPAIN', name: 'Euro', alphabetic_code: 'EUR', numeric_code: 978, exponent: 2 },
  { country: 'SRI LANKA', name: 'Sri Lanka Rupee', alphabetic_code: 'LKR', numeric_code: 144, exponent: 2 },
  { country: 'SUDAN (THE)', name: 'Sudanese Pound', alphabetic_code: 'SDG', numeric_code: 938, exponent: 2 },
  { country: 'SURINAME', name: 'Surinam Dollar', alphabetic_code: 'SRD', numeric_code: 968, exponent: 2 },
  { country: 'SVALBARD AND JAN MAYEN', name: 'Norwegian Krone', alphabetic_code: 'NOK', numeric_code: 578, exponent: 2 },
  { country: 'ESWATINI', name: 'Lilangeni', alphabetic_code: 'SZL', numeric_code: 748, exponent: 2 },
  { country: 'SWEDEN', name: 'Swedish Krona', alphabetic_code: 'SEK', numeric_code: 752, exponent: 2 },
  { country: 'SWITZERLAND', name: 'Swiss Franc', alphabetic_code: 'CHF', numeric_code: 756, exponent: 2 },
  { country: 'SWITZERLAND', name: 'WIR Euro', alphabetic_code: 'CHE', numeric_code: 947, exponent: 2 },
  { country: 'SWITZERLAND', name: 'WIR Franc', alphabetic_code: 'CHW', numeric_code: 948, exponent: 2 },
  { country: 'SYRIAN ARAB REPUBLIC', name: 'Syrian Pound', alphabetic_code: 'SYP', numeric_code: 760, exponent: 2 },
  { country: 'TAIWAN (PROVINCE OF CHINA)', name: 'New Taiwan Dollar', alphabetic_code: 'TWD', numeric_code: 901, exponent: 2 },
  { country: 'TAJIKISTAN', name: 'Somoni', alphabetic_code: 'TJS', numeric_code: 972, exponent: 2 },
  { country: 'TANZANIA, UNITED REPUBLIC OF', name: 'Tanzanian Shilling', alphabetic_code: 'TZS', numeric_code: 834, exponent: 2 },
  { country: 'THAILAND', name: 'Baht', alphabetic_code: 'THB', numeric_code: 764, exponent: 2 },
  { country: 'TIMOR-LESTE', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'TOGO', name: 'CFA Franc BCEAO', alphabetic_code: 'XOF', numeric_code: 952, exponent: 0 },
  { country: 'TOKELAU', name: 'New Zealand Dollar', alphabetic_code: 'NZD', numeric_code: 554, exponent: 2 },
  { country: 'TONGA', name: 'Pa’anga', alphabetic_code: 'TOP', numeric_code: 776, exponent: 2 },
  { country: 'TRINIDAD AND TOBAGO', name: 'Trinidad and Tobago Dollar', alphabetic_code: 'TTD', numeric_code: 780, exponent: 2 },
  { country: 'TUNISIA', name: 'Tunisian Dinar', alphabetic_code: 'TND', numeric_code: 788, exponent: 3 },
  { country: 'TURKEY', name: 'Turkish Lira', alphabetic_code: 'TRY', numeric_code: 949, exponent: 2 },
  { country: 'TURKMENISTAN', name: 'Turkmenistan New Manat', alphabetic_code: 'TMT', numeric_code: 934, exponent: 2 },
  { country: 'TURKS AND CAICOS ISLANDS (THE)', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'TUVALU', name: 'Australian Dollar', alphabetic_code: 'AUD', numeric_code: 36, exponent: 2 },
  { country: 'UGANDA', name: 'Uganda Shilling', alphabetic_code: 'UGX', numeric_code: 800, exponent: 0 },
  { country: 'UKRAINE', name: 'Hryvnia', alphabetic_code: 'UAH', numeric_code: 980, exponent: 2 },
  { country: 'UNITED ARAB EMIRATES (THE)', name: 'UAE Dirham', alphabetic_code: 'AED', numeric_code: 784, exponent: 2 },
  {
    country: 'UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND (THE)',
    name: 'Pound Sterling',
    alphabetic_code: 'GBP',
    numeric_code: 826,
    exponent: 2
  },
  {
    country: 'UNITED STATES MINOR OUTLYING ISLANDS (THE)',
    name: 'US Dollar',
    alphabetic_code: 'USD',
    numeric_code: 840,
    exponent: 2
  },
  { country: 'UNITED STATES OF AMERICA (THE)', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  {
    country: 'UNITED STATES OF AMERICA (THE)',
    name: 'US Dollar (Next day)',
    alphabetic_code: 'USN',
    numeric_code: 997,
    exponent: 2
  },
  { country: 'URUGUAY', name: 'Peso Uruguayo', alphabetic_code: 'UYU', numeric_code: 858, exponent: 2 },
  { country: 'URUGUAY', name: 'Uruguay Peso en Unidades Indexadas (UI)', alphabetic_code: 'UYI', numeric_code: 940, exponent: 0 },
  { country: 'URUGUAY', name: 'Unidad Previsional', alphabetic_code: 'UYW', numeric_code: 927, exponent: 4 },
  { country: 'UZBEKISTAN', name: 'Uzbekistan Sum', alphabetic_code: 'UZS', numeric_code: 860, exponent: 2 },
  { country: 'VANUATU', name: 'Vatu', alphabetic_code: 'VUV', numeric_code: 548, exponent: 0 },
  {
    country: 'VENEZUELA (BOLIVARIAN REPUBLIC OF)',
    name: 'Bolívar Soberano',
    alphabetic_code: 'VES',
    numeric_code: 928,
    exponent: 2
  },
  { country: 'VIET NAM', name: 'Dong', alphabetic_code: 'VND', numeric_code: 704, exponent: 0 },
  { country: 'VIRGIN ISLANDS (BRITISH)', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'VIRGIN ISLANDS (U.S.)', name: 'US Dollar', alphabetic_code: 'USD', numeric_code: 840, exponent: 2 },
  { country: 'WALLIS AND FUTUNA', name: 'CFP Franc', alphabetic_code: 'XPF', numeric_code: 953, exponent: 0 },
  { country: 'WESTERN SAHARA', name: 'Moroccan Dirham', alphabetic_code: 'MAD', numeric_code: 504, exponent: 2 },
  { country: 'YEMEN', name: 'Yemeni Rial', alphabetic_code: 'YER', numeric_code: 886, exponent: 2 },
  { country: 'ZAMBIA', name: 'Zambian Kwacha', alphabetic_code: 'ZMW', numeric_code: 967, exponent: 2 },
  { country: 'ZIMBABWE', name: 'Zimbabwe Dollar', alphabetic_code: 'ZWL', numeric_code: 932, exponent: 2 },
  {
    country: 'ZZ01_Bond Markets Unit European_EURCO',
    name: 'Bond Markets Unit European Composite Unit (EURCO)',
    alphabetic_code: 'XBA',
    numeric_code: 955,
    exponent: null
  },
  {
    country: 'ZZ02_Bond Markets Unit European_EMU-6',
    name: 'Bond Markets Unit European Monetary Unit (E.M.U.-6)',
    alphabetic_code: 'XBB',
    numeric_code: 956,
    exponent: null
  },
  {
    country: 'ZZ03_Bond Markets Unit European_EUA-9',
    name: 'Bond Markets Unit European Unit of Account 9 (E.U.A.-9)',
    alphabetic_code: 'XBC',
    numeric_code: 957,
    exponent: null
  },
  {
    country: 'ZZ04_Bond Markets Unit European_EUA-17',
    name: 'Bond Markets Unit European Unit of Account 17 (E.U.A.-17)',
    alphabetic_code: 'XBD',
    numeric_code: 958,
    exponent: null
  },
  {
    country: 'ZZ06_Testing_Code',
    name: 'Codes specifically reserved for testing purposes',
    alphabetic_code: 'XTS',
    numeric_code: 963,
    exponent: null
  },
  {
    country: 'ZZ07_No_Currency',
    name: 'The codes assigned for transactions where no currency is involved',
    alphabetic_code: 'XXX',
    numeric_code: 999,
    exponent: null
  },
  { country: 'ZZ08_Gold', name: 'Gold', alphabetic_code: 'XAU', numeric_code: 959, exponent: null },
  { country: 'ZZ09_Palladium', name: 'Palladium', alphabetic_code: 'XPD', numeric_code: 964, exponent: null },
  { country: 'ZZ10_Platinum', name: 'Platinum', alphabetic_code: 'XPT', numeric_code: 962, exponent: null },
  { country: 'ZZ11_Silver', name: 'Silver', alphabetic_code: 'XAG', numeric_code: 961, exponent: null }
];
